import React, { useState } from "react";
import VmoBrandLogo from "../Custom/VmoBrandLogo";
import PropTypes from "prop-types";
import VmoContainer from "../Elements/VmoContainer";
import VmoForm from "../Collections/VmoForm/VmoForm";
import VmoFormInput from "../Collections/VmoForm/VmoFormInput";
import VmoButton from "../Elements/VmoButton/VmoButton";
import VmoCard from "../Views/VmoCard/VmoCard";
import VmoCardContent from "../Views/VmoCard/VmoCardContent";
import { Controller, useForm } from "react-hook-form";
import { MdLanguage } from "react-icons/md";
import { FiMail, FiUser, FiLock, FiBriefcase } from "react-icons/fi";
import VmoSignupTestimonial from "./VmoSignupTestimonial";
import VmoGrid from "../Collections/VmoGrid/VmoGrid";
import VmoGridColumn from "../Collections/VmoGrid/VmoGridColumn";
import VmoPhoneInput from "../Custom/VmoPhoneInput";
import { joiResolver } from "@hookform/resolvers/joi";
import { signupSchema } from "../Validation/common.schema";

export default function VmoSignup({
  onSignup = () => null,
  signInUrl = "/signin",
  onSignIn = () => null,
  onTerms = () => null,
  onPrivacy = () => null,
  testimoial = null,
  header = "Sign up to Veemo.",
  subheader = "Start 15 Days FREE Trial for Veemo.",
  btnLabel = "Start 15 Days Free Trial",
  defaultPhoneCode = "+61",
  domainProps = {
    action: {
      color: "blue",
      content: ".veemosupport.xyz",
    },
  },
  buttonProps = {
    disabled: false,
    loading: false,
  },
  testIds = {},
}) {
  const [showPwd, setShowPwd] = useState(false);
  const {
    handleSubmit,
    control,
    formState: { errors, isDirty },
    setValue,
    clearErrors,
  } = useForm({
    mode: "onTouched",
    shouldFocusError: true,
    reValidateMode: "onChange",
    submitFocusError: true,
    shouldUnregister: false,
    resolver: joiResolver(signupSchema),
    defaultValues: {
      email: "",
      phone: "",
      firstName: "",
      lastName: "",
      domain: "",
      password: "",
      company: "",
      phone: {
        code: defaultPhoneCode,
        phone: "",
      },
    },
  });

  function handleCompanyChange(e) {
    let value = e.target.value;
    setValue(
      "domain",
      encodeURI(value.toLowerCase().split(".").join("").split(" ").join(""))
    );
    clearErrors("domain");
  }
  return (
    <VmoContainer fluid data-testid={testIds.container}>
      <VmoGrid className="signUpPage">
        <VmoGridColumn
          style={{ padding: "48px" }}
          className="singupTestiMonial"
        >
          {testimoial ? testimoial : <VmoSignupTestimonial />}
        </VmoGridColumn>
        <VmoGridColumn className="signUpPageRight">
          <div className="signInPage">
            <div className="signInBody">
              <VmoBrandLogo className={"veemo-logo"} />
              <VmoCard className="loginCard">
                <VmoCardContent>
                  <h1>{header}</h1>
                  <p className="vmo-lead">{subheader}</p>
                  <VmoForm size="large" onSubmit={handleSubmit(onSignup)}>
                    <Controller
                      name="firstName"
                      render={({ field: { value, onChange } }) => (
                        <VmoFormInput
                          type="text"
                          fluid
                          icon={<FiUser />}
                          iconPosition="left"
                          placeholder="First name"
                          className="errorLabelMl"
                          error={
                            errors.firstName && {
                              content: errors.firstName.message,
                            }
                          }
                          value={value}
                          onChange={(e) => onChange(e.target.value)}
                          data-testid={testIds.firstNameInput}
                        />
                      )}
                      control={control}
                    />
                    <Controller
                      name="lastName"
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <VmoFormInput
                          fluid
                          type="text"
                          icon={<FiUser />}
                          iconPosition="left"
                          className="errorLabelMl"
                          placeholder="Last name"
                          error={
                            errors.lastName && {
                              content: errors.lastName.message,
                            }
                          }
                          value={value}
                          onChange={(e) => onChange(e.target.value)}
                          data-testid={testIds.lastNameInput}
                        />
                      )}
                    />
                    <Controller
                      name="email"
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <VmoFormInput
                          fluid
                          type="email"
                          icon={<FiMail />}
                          iconPosition="left"
                          placeholder="Email Address"
                          error={
                            errors.email && {
                              content: errors.email.message,
                            }
                          }
                          value={value}
                          onChange={(e) => onChange(e.target.value)}
                          data-testid={testIds.emailInput}
                        />
                      )}
                    />
                    <Controller
                      name="password"
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <VmoFormInput
                          fluid
                          value={value}
                          onChange={(e) => {
                            onChange(e.target.value);
                          }}
                          type={!showPwd ? "password" : "text"}
                          icon={<FiLock />}
                          iconPosition="left"
                          placeholder="Enter Password"
                          action={{
                            color: "basic",
                            tabindex: -1,
                            icon: !showPwd ? "eye slash" : "eye",
                            onClick: (e) => {
                              e.preventDefault();
                              setShowPwd(!showPwd);
                            },
                          }}
                          error={
                            errors.password && {
                              content: errors.password.message,
                            }
                          }
                          data-testid={testIds.passwordInput}
                        />
                      )}
                    />
                    <Controller
                      name="phone"
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <VmoPhoneInput
                          showFlag
                          defaultPhoneCode={defaultPhoneCode}
                          onChange={(e) => {
                            onChange(e);
                          }}
                          inputProps={{
                            placeholder: "Enter the phone number",
                          }}
                          value={value}
                          error={
                            errors &&
                            (errors?.phone?.message ||
                              errors?.phone?.phoneCode?.message ||
                              errors?.phone?.phone?.message)
                          }
                          data-testid={testIds.phoneInput}
                        />
                      )}
                    />
                    <Controller
                      name="company"
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <VmoFormInput
                          fluid
                          type="text"
                          icon={<FiBriefcase />}
                          value={value}
                          onChange={(e) => {
                            handleCompanyChange(e);
                            onChange(e.target.value);
                          }}
                          iconPosition="left"
                          placeholder="Enter Company"
                          error={
                            errors.company && {
                              content: errors.company.message,
                            }
                          }
                          data-testid={testIds.companyInput}
                        />
                      )}
                    />
                    <Controller
                      name="domain"
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <VmoFormInput
                          type="text"
                          fluid
                          className="domain-postfix"
                          icon={<MdLanguage />}
                          iconPosition="left"
                          placeholder="Domain"
                          value={value}
                          onChange={(e) => onChange(e.target.value)}
                          error={
                            errors.domain && {
                              content:
                                errors.domain.message ||
                                (errors.domain.type === "validate" &&
                                  "Domain already taken"),
                            }
                          }
                          {...domainProps}
                          data-testid={testIds.domainInput}
                        />
                      )}
                    />
                    <VmoButton
                      primary
                      type="submit"
                      fluid
                      size="large"
                      disabled={isDirty || buttonProps?.disabled}
                      {...buttonProps}
                      data-testid={testIds.submitButton}
                    >
                      {btnLabel}
                    </VmoButton>
                  </VmoForm>

                  <p
                    className="vmo-lead mt-3 mb-0 tc-privacy-policy"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    By signing up, you agree to our{" "}
                    <a href onClick={onTerms}>
                      T & C
                    </a>{" "}
                    and{" "}
                    <a href onClick={onPrivacy}>
                      Privacy policy
                    </a>
                  </p>
                </VmoCardContent>
              </VmoCard>
            </div>
            <p className="vmo-lead cursor-pointer">
              Already have an account?{` `}
              <a href={signInUrl} onClick={onSignIn}>
                Sign In
              </a>
            </p>
          </div>
        </VmoGridColumn>
      </VmoGrid>
    </VmoContainer>
  );
}

VmoSignup.propTypes = {
  onSignup: PropTypes.func.isRequired,
  signInUrl: PropTypes.string.isRequired,
  onSignIn: PropTypes.func,
  onTerms: PropTypes.func,
  onPrivacy: PropTypes.func,
  btnLabel: PropTypes.string,
  testimoial: PropTypes.node,
  header: PropTypes.string,
  subheader: PropTypes.string,
  defaultPhoneCode: PropTypes.string,
  domainProps: PropTypes.shape({
    action: PropTypes.shape({
      color: PropTypes.string,
      content: PropTypes.string,
    }),
    testIds: PropTypes.shape({
      container: PropTypes.string,
      brandLogo: PropTypes.string,
      form: PropTypes.string,
      submitButton: PropTypes.string,
      signInLink: PropTypes.string,
      companyInput: PropTypes.string,
      domainInput: PropTypes.string,
      phoneInput: PropTypes.string,
      phoneCodeInput: PropTypes.string,
      phoneCodeDropdown: PropTypes.string,
      phoneCodeDropdownItem: PropTypes.string,
      phoneCodeDropdownItemFlag: PropTypes.string,
      phoneCodeDropdownItemContent: PropTypes.string,
      phoneCodeDropdownItemActive: PropTypes.string,
      passwordInput: PropTypes.string,
      emailInput: PropTypes.string,
      lastNameInput: PropTypes.string,
      firstNameInput: PropTypes.string,
    }),
  }),
  buttonProps: PropTypes.shape({
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
  }),
};

VmoSignup.defaultProps = {
  onSignup: () => null,
  signInUrl: "/signin",
  onSignIn: () => null,
  onTerms: () => null,
  onPrivacy: () => null,
  testimoial: null,
  header: "Sign up to Veemo.",
  subheader: "Start 15 Days FREE Trial for Veemo.",
  btnLabel: "Start 15 Days Free Trial",
  defaultPhoneCode: null,
  domainProps: {
    action: {
      color: "blue",
      content: ".veemosupport.xyz",
    },
    testIds: {
      container: "container",
      brandLogo: "brand-logo",
      form: "form",
      submitButton: "submit-button",
      signInLink: "sign-in-link",
      companyInput: "company-input",
      domainInput: "domain-input",
      phoneInput: "phone-input",
      phoneCodeInput: "phone-code-input",
      phoneCodeDropdown: "phone-code-dropdown",
      phoneCodeDropdownItem: "phone-code-dropdown-item",
      phoneCodeDropdownItemFlag: "phone-code-dropdown-item-flag",
      phoneCodeDropdownItemContent: "phone-code-dropdown-item-content",
      phoneCodeDropdownItemActive: "phone-code-dropdown-item-active",
      passwordInput: "password-input",
      emailInput: "email-input",
      lastNameInput: "last-name-input",
      firstNameInput: "first-name-input",
    },
  },
  buttonProps: {
    disabled: false,
    loading: false,
  },
};
